export default __webpack_public_path__ + "static/media/Pilgrim's Belt of Shimmering Light.c0d29388.jpg";